import React, { useMemo, ReactNode } from 'react';
import { mathCal } from '@helpers/numHelpers';
import { RelatedDocumentItem } from '@layouts/Related/Related.types';

export const useItemsToRender = ({
  renderItem,
  filteredList,
}: {
  renderItem: (item: RelatedDocumentItem) => ReactNode;
  filteredList: RelatedDocumentItem[];
}) => {
  const offset = 8;
  const defaultOffset = 4;

  const items = useMemo(() => {
    let itemsToRender: ReactNode[] = [];

    if (!filteredList) return null;

    if (filteredList.length < defaultOffset) {
      itemsToRender = filteredList.map((item) => <div key={item.Url}>{renderItem(item)}</div>);
    } else {
      let lastValue = 0;
      const defaultList = filteredList.slice(0, defaultOffset);
      itemsToRender = defaultList.map((item) => <div key={item.Url}>{renderItem(item)}</div>);
      const total = filteredList.length;
      const nextList = filteredList.slice(defaultOffset, total);
      const roundedTotal = mathCal(nextList.length, offset);

      for (let i = 1; i <= roundedTotal; i++) {
        if (i % offset == 0) {
          const listIterationObj = nextList ? nextList.slice(lastValue, i) : null;
          if (listIterationObj) {
            listIterationObj.map((item, index) => {
              const Data = (
                <div
                  key={`${index}_${i}`}
                  className={`hidden related-document-block`}
                  id={`${index}related-document-block${i}`}
                  data-related-block={'documentlist' + i}
                >
                  {renderItem(item)}
                </div>
              );
              itemsToRender.push(Data);
              return itemsToRender;
            });
          }

          lastValue = i;
        }
      }
    }
    return itemsToRender;
  }, [renderItem, filteredList]);
  return items;
};
